import { DialogContent, DialogTitle } from "@mui/material";
import type { PropsWithChildren, ReactNode } from "react";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";

export const previewFailedTitle = "We couldn't load this document";

interface Props {
  title: string;
  onClose: () => void;
  closeDisabled?: boolean;
  actions?: ReactNode;
}

const PreviewStatusDialog = ({ title, onClose, closeDisabled, actions, children }: PropsWithChildren<Props>) => (
  <SmallDialog open onClose={closeDisabled ? undefined : onClose}>
    <DialogTitle>{title}</DialogTitle>
    {!closeDisabled && <DialogCloseButton onClick={onClose} />}
    <DialogContent>{children}</DialogContent>
    <DialogButtons onCancel={onClose} cancelText="Close" cancelDisabled={closeDisabled}>
      {actions}
    </DialogButtons>
  </SmallDialog>
);

export default PreviewStatusDialog;
